export const dictionary = {
  PAGE_TITLE: {
    ES: "Configuración de tu cuenta",
    EN: "Account settings",
  },
  REQUIRED: {
    ES: "Datos requeridos",
    EN: "Required",
  },
  OPTIONAL: {
    ES: "Datos opcionales",
    EN: "Optional",
  },
  BUSINESS_NAME: {
    ES: "Nombre del comercio",
    EN: "Business name",
  },
  DESCRIPTION: {
    ES: "Describe de que se trata tu tienda (opcional)",
    EN: "Store description (optional)",
  },
  LOGO: {
    ES: "Añade tu logo",
    EN: "Add your logo",
  },
  BANNER_INFO: {
    ES: "Mensaje que quieres que aparezca en tu tienda (opcional)",
    EN: "Message you want to show in your store (optional)",
  },
  ADMIN_NAME: {
    ES: "Nombre del administrador",
    EN: "Admin name",
  },
  CONTACT_NUMBER: {
    ES: "Teléfono de contacto",
    EN: "Contact number",
  },
  WHATSAPP: {
    ES: "Whatsapp de tu negocio",
    EN: "Business Whatsapp",
  },
  CONTACT_EMAIL: {
    ES: "Email de contacto",
    EN: "Contact email",
  },
  CURRENCY: {
    ES: "Moneda",
    EN: "Currency",
  },
  FEATURES: {
    ES: "Funcionalidad",
    EN: "Features",
  },
  FEATURES_WHATSAPP: {
    ES: "Recibir pedidos por whatsapp",
    EN: "Whatsapp",
  },
  FEATURES_CATALOGO: {
    ES: "Solo catálogo",
    EN: "Catalogue",
  },
  FEATURES_BAR_FULL: {
    ES: "Bar",
    EN: "Features",
  },
  BUSINESS_ADDRESS: {
    ES: "Dirección del comercio",
    EN: "Business address",
  },
  ADDRESS: {
    ES: "Calle y número del comercio",
    EN: "Business address",
  },
  ZIP_CODE: {
    ES: "Código postal",
    EN: "Zip code",
  },
  CITY: {
    ES: "Ciudad",
    EN: "City",
  },
  PROVINCE: {
    ES: "Provincia/Región",
    EN: "Province",
  },
  COUNTRY: {
    ES: "País",
    EN: "Country",
  },
  USER_NAME: {
    ES: "Usuario en ",
    EN: "Username in ",
  },
  TITLE_ADDRESS: {
    ES: "Introduce tu dirección comercial",
    EN: "Business address",
  },
  INPUTS_ADDRESS: {
    ES: "Introducir manualmente",
    EN: "Set manually",
  },
} as const;
